//@flow

import React from "react";
import { Field } from "react-final-form";
import type { FieldRenderProps } from "react-final-form";

import { required } from "modules/ChangeServiceForm/misc/validations";
import { Dropdown } from "../../../../shared/CommonComponents";

const Salutation = ({ fieldName }: { fieldName: string }) => {
  const options = [
    { text: "Frau", value: "Frau" },
    { text: "Herr", value: "Herr" },
  ];

  return (
    <Field name={fieldName} validate={required}>
      {({ input: { onChange, value }, meta }: FieldRenderProps) => {
        return (
          <Dropdown
            fullWidth
            placeholder="Anrede"
            options={options}
            onChange={onChange}
            value={value}
            errorMessage={(meta.modified || meta.touched) && meta.error}
            error={(meta.modified || meta.touched) && meta.error}
          />
        );
      }}
    </Field>
  );
};

export default Salutation;
